export default __webpack_public_path__ + "static/Lizmap-videoprotection-cea8b4b2a6db842518c54fc5ec1d5b47.mp4";